var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImageAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7",
    "data-name": "\\uADF8\\uB8F9 7",
    transform: "translate(-365 -337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_5",
    "data-name": "\\uD0C0\\uC6D0 5",
    transform: "translate(365 337)",
    fill: "#fff",
    stroke: "#e4e4e4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_5",
    "data-name": "\\uC120 5",
    y2: 50,
    transform: "translate(415 362)",
    fill: "none",
    stroke: "#e4e4e4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_6",
    "data-name": "\\uC120 6",
    y2: 50,
    transform: "translate(440 387) rotate(90)",
    fill: "none",
    stroke: "#e4e4e4",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImageAdd);
export default __webpack_public_path__ + "static/media/profile_image_add.b8faac1ea746e4b11dd26c340a7ba892.svg";
export { ForwardRef as ReactComponent };